export default __webpack_public_path__ + "static/media/mQuickstarter_badge.3f23f3f7.svg";